import { Form } from '@anytag/shared-atoms';
import { namedOperations } from '@anytag/graphql';
import { UpdateCostsFormValues, useUpdatePostPrices } from '../../hooks';
import { getRevenueItems } from '../../MarketplaceJoinedInfluencers/utils';
import { Template, TemplateProps } from './template';

export type MarketplacePostsListProps = TemplateProps;

export const MarketplacePostsList = (props: MarketplacePostsListProps) => {
  const { posts, marketplace } = props;

  const { handleUpdatePostPrices } = useUpdatePostPrices({
    marketplaceId: marketplace.id,
    refetchQueries: [namedOperations.Query.AllMarketplacePosts]
  });

  return (
    <Form.Provider<UpdateCostsFormValues>
      onSubmit={handleUpdatePostPrices}
      values={posts?.reduce<UpdateCostsFormValues>((rs, post) => {
        const {
          revenuePerPost,
          revenuePerLike,
          revenuePerView,
          revenuePerShare,
          revenuePerClick,
          revenuePerAction,
          revenuePerComment
        } = getRevenueItems(post.revenueItems);

        rs[`${post.influencer.id}_revenuePerPost`] = revenuePerPost?.value?.toString() || '';
        rs[`${post.influencer.id}_revenuePerLike`] = revenuePerLike?.value?.toString() || '';
        rs[`${post.influencer.id}_revenuePerView`] = revenuePerView?.value?.toString() || '';
        rs[`${post.influencer.id}_revenuePerShare`] = revenuePerShare?.value?.toString() || '';
        rs[`${post.influencer.id}_revenuePerClick`] = revenuePerClick?.value?.toString() || '';
        rs[`${post.influencer.id}_revenuePerComment`] = revenuePerComment?.value?.toString() || '';
        rs[`${post.influencer.id}_revenuePerAction`] = revenuePerAction?.value?.toString() || '';

        return rs;
      }, {})}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault(); // Prevent form submit on Enter key, user needs to click the Save button
        }
      }}
    >
      <Template {...props} />
    </Form.Provider>
  );
};
